import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_blinker",
  "use": "icon-icon_blinker-usage",
  "viewBox": "0 0 16 42",
  "content": "<symbol viewBox=\"0 0 16 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_blinker\">\n<rect x=\"0.5\" y=\"0.5\" width=\"14.75\" height=\"41\" rx=\"5.5\" fill=\"white\" stroke=\"black\" />\n<circle cx=\"7.875\" cy=\"7.875\" r=\"4.75\" fill=\"#FF0000\" stroke=\"black\" />\n<circle cx=\"7.875\" cy=\"21\" r=\"4.75\" fill=\"#FFB800\" stroke=\"black\" />\n<circle cx=\"7.875\" cy=\"34.125\" r=\"4.75\" fill=\"#36A325\" stroke=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol